import request from "../request";

export default {
  // 列表
  lists(data) {
    return request.get("/adminCategory/lists", data);
  },

  //添加
  add(data) {
    return request.post("/adminCategory/add", data);
  },

  // 编辑
  edit(data) {
    return request.post("/adminCategory/edit", data);
  },

  // 删除
  delete(data) {
    return request.post("/adminCategory/delete", data);
  },

};
